import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"
import {SourceOfIncome, SourceOfIncomeMapping} from "../../resources/application"

export interface EditableSourceOfIncomeProps {
	sourceOfIncome?: SourceOfIncome
	setSourceOfIncome: (value: SourceOfIncome) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: SourceOfIncome) => void
	className?: string
}

export function EditableSourceOfIncomeField(props: EditableSourceOfIncomeProps) {
	if (props.sourceOfIncome) {
		return (
			<Editable
				label="Source of Income"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setSourceOfIncome}
				value={props.sourceOfIncome}
				initial={props.sourceOfIncome}
				update={props.update}
				className={props.className}
				possibleValues={SourceOfIncomeMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}
	return null
}
